import React from 'react';
import { get_image_endpoint } from '../../ImageEndpoint';
import styles from './InviteContainer.scss';

const InviteHeader = ({ company }) => (
  <>
    <div>&nbsp;</div>
    {company?.alias && (
      <div className={styles['c-invite__logo']}>
        <img
          src={get_image_endpoint(company.alias, 'dark')}
          alt={`${company.name} logo`}
        />
      </div>
    )}
  </>
);
export default InviteHeader;
